import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import { ErrorIcon } from '../icons';
import styles from './styles.module.css';
import { Icon } from '../icon';
/**
 * Компонент `<Caption />` служит для отображения текста в виде подписи.
 * @example
 * ```jsx
 * <Caption message="Your fancy caption" captionSize="s" warning />
 * ```
 */

export const Caption = /*#__PURE__*/forwardRef(function Caption(props, ref) {
  const {
    message,
    error,
    warning,
    mobile,
    className,
    captionSize,
    ...otherProps
  } = props;
  const captionClassName = useMemo(() => clsx(styles.caption, captionSize && styles[captionSize], className, {
    [styles.captionError]: error,
    [styles.captionMobile]: mobile
  }), [className, error, mobile, captionSize]);
  const hasIcon = useMemo(() => error || warning, [error, warning]);
  return message ? /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: captionClassName,
    ...otherProps
  }, hasIcon && /*#__PURE__*/React.createElement(Icon, {
    size: 16,
    className: styles.captionIcon
  }, /*#__PURE__*/React.createElement(ErrorIcon, null)), message) : null;
});